export default {
  "layout-default": () => import("/opt/render/project/src/layouts/LayoutDefault.vue").then(m => m.default || m),
  "layout-minimal": () => import("/opt/render/project/src/layouts/LayoutMinimal.vue").then(m => m.default || m)
}